type HeroBackdropProps = {
  compact?: boolean;
};

/** Restrained map-and-route texture shared by Geofleet hero sections. */
export default function HeroBackdrop({ compact = false }: HeroBackdropProps) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <div
        className="absolute inset-0 opacity-[0.11]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(145,189,255,0.22) 1px, transparent 1px), linear-gradient(90deg, rgba(145,189,255,0.22) 1px, transparent 1px)',
          backgroundSize: compact ? '64px 64px' : '72px 72px',
          maskImage: 'linear-gradient(to bottom, black, transparent 82%)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent 82%)',
        }}
      />
      <svg
        viewBox="0 0 1600 720"
        preserveAspectRatio="none"
        className={`absolute inset-x-0 top-0 w-full ${compact ? 'h-[360px]' : 'h-[680px]'}`}
      >
        <path
          d="M-80 530 C180 500 210 315 445 340 S760 560 980 390 S1260 160 1690 245"
          fill="none"
          stroke="#5c9aff"
          strokeWidth="1.5"
          strokeDasharray="8 14"
          opacity="0.25"
        />
        <path
          d="M70 145 C320 240 430 90 660 185 S965 315 1190 205 S1420 105 1660 150"
          fill="none"
          stroke="#ffffff"
          strokeWidth="1"
          opacity="0.09"
        />
        {[
          [244, 430],
          [445, 340],
          [790, 480],
          [1010, 365],
          [1295, 190],
        ].map(([cx, cy]) => (
          <g key={`${cx}-${cy}`}>
            <circle cx={cx} cy={cy} r="8" fill="#071421" stroke="#5c9aff" strokeWidth="2" opacity="0.7" />
            <circle cx={cx} cy={cy} r="2.5" fill="#91bdff" opacity="0.9" />
          </g>
        ))}
      </svg>
      <div className="absolute inset-x-0 bottom-0 h-px bg-white/10" />
    </div>
  );
}
